/** Client-owned preferences — stored on the user doc, never engine-written. */
export function defaultNotificationSettings() {
    return {
        pickReminders: true,
        newRound: true,
        results: true,
        h2hChallenges: true,
        friendActivity: false,
        liveScores: true,
        miniLeagues: true,
        announcements: true
    };
}
export function defaultPrivacySettings() {
    return {
        visibility: 'public',
        showOnLeaderboards: true,
        showPredictorDna: true,
        showLockedCards: false,
        searchableByUsername: true,
        friendRivalRequests: true
    };
}
export function defaultUserSettings() {
    return {
        notifications: defaultNotificationSettings(),
        privacy: defaultPrivacySettings()
    };
}
/** Merge a partial settings blob onto defaults (handles older docs). */
export function resolveUserSettings(partial) {
    const base = defaultUserSettings();
    if (!partial)
        return base;
    return {
        notifications: { ...base.notifications, ...partial.notifications },
        privacy: { ...base.privacy, ...partial.privacy }
    };
}
/**
 * Which notification preference governs each engine-emitted notification type.
 * The map is exhaustive over `NotificationType`, so adding a new type without a
 * category is a compile error — every notification must answer to a settings toggle.
 */
export const NOTIFICATION_CATEGORY = {
    NEW_ROUND: 'newRound',
    PICKS_LOCK_SOON: 'pickReminders',
    ROUND_SETTLED: 'results',
    PROMOTED: 'results',
    RELEGATED: 'results',
    EXACT_BONUS: 'results',
    SCORER_BONUS: 'results',
    FRIEND_PASSED: 'friendActivity',
    DUEL_CHALLENGE: 'h2hChallenges',
    DUEL_RESULT: 'h2hChallenges',
    MATCH_KICKOFF: 'liveScores',
    LIVE_GOAL: 'liveScores',
    MATCH_RESULT: 'liveScores',
    MINI_LEAGUE_JOIN: 'miniLeagues',
    MINI_LEAGUE_RESULT: 'miniLeagues',
    // A mini-league round reminder is fundamentally a "get your picks in" nudge, so it
    // answers to the pickReminders toggle — that also lets it cleanly replace the
    // generic reminder for members of reminder-enabled mini leagues (no double-ping).
    MINI_LEAGUE_REMINDER: 'pickReminders',
    // Manually-broadcast product/marketing pushes answer to their own opt-out so a
    // player can mute promos without losing gameplay notifications.
    ANNOUNCEMENT: 'announcements'
};
/**
 * Whether a user wants a given notification type, resolving a possibly-partial or
 * absent settings blob onto the defaults first. The single gate both the engine
 * (before writing to a feed) and the client share, so a toggle in Settings always
 * matches what actually gets delivered.
 */
export function isNotificationEnabled(settings, type) {
    return resolveUserSettings(settings).notifications[NOTIFICATION_CATEGORY[type]];
}
//# sourceMappingURL=settings.js.map